function onboardingDialog () {
  return {
    restrict: 'E',
    templateUrl: '/core/dialogs/onboarding-dialog/onboarding-dialog.html?$$REVISION$$'
  }
}

export { onboardingDialog }
